import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {Arrow} from '/app/src/component'


class PageItem extends React.Component {
    render(){
        let classNames = style.PageItem
        if(this.props.currentPage === this.props.page){
            classNames += ' ' + style.Active
        }
        return(
            <Flex
                onClick={this.props.onClick}
                hAlignContent='center' vAlignContent='center' className={classNames}>
                {this.props.page}
            </Flex>
        )
    }
}

export default class Pagination extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            itemCounts: this.props.itemCounts,
            itemPerPage: this.props.itemPerPage,
            currentPage: this.props.currentPage,
            pageCounts: Math.ceil(this.props.itemCounts/(this.props.itemPerPage))
        }
        this._renderPages = this._renderPages.bind(this)

    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            itemCounts: nextProps.itemCounts,
            pageCounts: Math.ceil(nextProps.itemCounts/(nextProps.itemPerPage))
        })
    }

    _onClick(index){
        return () => {
            if(index <= 1){
                index=1;
            }
            if(index >= this.state.pageCounts){
                index = this.state.pageCounts;
            }
            this.setState({currentPage: index})
            this.props.onClick(index)
        }
    }

    _range(start, stop){
        var a=[start], b=start;
        while(b<stop){b+=1;a.push(b)}
        return a;
    }

    _renderPages(){
        let currentPage = this.state.currentPage
        let minRange = currentPage -5
        let maxRange = currentPage + 4
        if(minRange < 1){
            minRange = 1
            maxRange = this.state.pageCounts < 10? this.state.pageCounts: 10
        }else if (maxRange > this.state.pageCounts){
            maxRange = this.state.pageCounts
            minRange = this.state.pageCounts - 9
            minRange = minRange < 1? 1: minRange
        }
        let pages = this._range(minRange, maxRange)
        pages = pages.map((page, index) => {
            return (<PageItem
                    key={index}
                    currentPage={this.state.currentPage} page={page}
                    onClick={this._onClick(page)}

                    />
                )
        })
        return pages
    }

    render(){
        return (
            <Flex className={style.Pagination}
                width='100%' vAlignContent='center' hAlignContent='center' >
                <Arrow direction='left' size='small' color='lightgrey' hover='blue' border='1px solid'
                    borderRadius='100%'
                    onClick = {this._onClick(this.state.currentPage-1)}
                />
                <Flex hAlignContent='center' vAlignContent='center' marginRight='20px' marginLeft='20px'>
                {this._renderPages()}
                </Flex>
                <Arrow direction='right' circleBorder size='small' color='lightgrey' hover='blue' border='1px solid'
                    borderRadius='100%'
                    onClick = {this._onClick(this.state.currentPage+1)}
                />

            </Flex>
        )
    }

    }



// WEBPACK FOOTER //
// ./src/component/Pagination/index.js